import { COMMON_CUSTOMERS_FIELDS } from "../../users_crew/conf/Data.conf";

export const Roles = [
	{ id: 'CAPTAIN', label: 'Captain'},
	{ id: 'CHEF', label: 'Chef'},
	{ id: 'PURSER', label: 'Purser'},
	{ id: 'FIRST OFFICER', label: 'First Officer'},
	{ id: 'CHIEF STEWARDESS', label: 'Chief Stewardess'},
	{ id: 'CHIEF ENGINEER', label: 'Chief Engineer'},
	{ id: 'OTHER', label: 'Other'},
	{ id: 'ROTATE CAPTAIN', label: 'Rotate Captain'},

];

export const DataConf = {
	initialState: {
		loading: false,
		error: null,
		data: [],
		meta: null,
	},
};


export const UsersType= [
	{ label: 'Crew', id: 'Crew' },
	{ label: 'Nautica', id: 'Nautica' },
  ]

export const getViewConfiguration = (userTypeSelect, crewResponsability, configObject) => {
	if (userTypeSelect?.id === 'Crew' && crewResponsability) {
		return COMMON_CUSTOMERS_FIELDS?.includes(crewResponsability?.label)
			? configObject[userTypeSelect?.id]?.Common
			: configObject[userTypeSelect?.id]?.[crewResponsability?.label];
	}
	if (userTypeSelect?.id === 'Nautica') {
		return configObject[userTypeSelect?.id];
	}
	return null;
};